import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-electable-signs',
  templateUrl: './admin-electable-signs.component.html',
  styleUrls: ['./admin-electable-signs.component.css']
})
export class AdminElectableSignsComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  electablesigns: any[] = [];
  cols: any[];
  institutiontypes: SelectItem[] = [];
  institutions: SelectItem[] = [];
  signs: SelectItem[] = [];
  display = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;
  signlist: any[] = [];
  institutionlist: any[] = [];

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    private institutionService: InstitutionsService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'signName', header: 'Utmärkelse' },
      { field: 'signAbbreviation', header: 'Förkortning' },
      { field: 'shortName', header: 'Institution' },
      { field: 'institutionTypeIdName', header: 'Institutionstyp' }
    ];
    this.getInstitutionTypes();
    this.getElectableSigns();
  }
  getElectableSigns() {
    this.adminService.GetElectableSigns().subscribe(resp => {
      if (resp) {
        this.electablesigns = resp;
      }
    });
  }

  getInstitutionTypes() {
    this.institutiontypes = [];
    this.institutionService.getInstitutionTypes().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.institutiontypes.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.institutiontypes.unshift(emptyrecord);
        this.getSigns();        
      }
    });
  }

  getSigns() {
    this.adminService.GetSigns().subscribe(response => {
      this.signlist = response;
      // tslint:disable-next-line: max-line-length
      this.signlist.unshift({ id: null, abbreviation: null, name: null, type: null, typeName: null });
      this.getInstitutions();
    });

  }

  getInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response;
      this.institutionlist.forEach(x => {
        x.name = x.name + '  [' + x.shortName + ']';
      });
      // tslint:disable-next-line: max-line-length
      this.institutionlist.unshift({});
    });
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera vald electable sign?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.deleteElectableSign(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteElectableSign(rowdata) {
    this.adminService.RemoveElectableSign(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Electable Sign raderad.' });
        this.getInstitutionTypes();
        this.getElectableSigns();
      }
    });
  }

  cancelAdd() {
    this.display = false;
  }

  saveElectableSigns(evt) {
    this.adminService.AddElectableSign(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Electable Sign tillagd.' });
        this.getElectableSigns();
      }
    });
    this.display = false;
  }

  add() {
    this.display = true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {
    let firstrow = '';
    // tslint:disable-next-line:max-line-length
    this.cols.forEach(c => {
      firstrow += c.header + ';';
    });
    const filnamn = 'OF_Electablesigns';
    const excelrecords: any[] = [];
    this.electablesigns.forEach(r => {
      const row = {
        signName: r.signName,
        signAbbreviation: r.signAbbreviation,
        shortName: r.shortName,
        institutionTypeIdName: r.institutionTypeIdName
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }
}
